// Add your custom JS here.

(function ($) {
  $(document).ready(function () {
    $('li.menu-item-has-children').on('mouseover', function () {
      let valueWidth = $(this).find('ul.dropdown-menu').width();
      $('li.menu-item-has-children ul li ul').css('left', valueWidth + 'px');
    });

    const svgPlus = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" aria-hidden="true" focusable="false"><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"/></svg>';
    const svgMinus = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" aria-hidden="true" focusable="false"><path d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"/></svg>';

    $('li.menu-item-has-children > a').after(
      '<span class="new-span d-inline-block d-xl-none ms-auto" aria-hidden="true">' + svgPlus + '</span>'
    );

    $('li.menu-item-has-children > span.new-span').on('click', function () {
      const $span = $(this);
      const isActive = $span.hasClass('active');
      $span.closest('li').children('ul').toggleClass('show');
      $span.toggleClass('active');
      $span.html(isActive ? svgPlus : svgMinus);
    });

  });

  jQuery(document).ready(function ($) {
    $('.testimonials-slider').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
      dots: true,
      infinite: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    $('.logocarousel').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  });
})(jQuery);
